import { render, staticRenderFns } from "./customEvent.vue?vue&type=template&id=dd2d0cc4&scoped=true"
import script from "./customEvent.vue?vue&type=script&lang=js"
export * from "./customEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2d0cc4",
  null
  
)

export default component.exports